import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a52b9132&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52b9132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52b9132')) {
      api.createRecord('a52b9132', component.options)
    } else {
      api.reload('a52b9132', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=a52b9132&scoped=true", function () {
      api.rerender('a52b9132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/lock/add.vue"
export default component.exports